/**
 * Given a product slug, return the relative path to single product page
 *
 * @param {String} slug - product slug
 */
export const fromProductSlugToUrl = ( slug ) => `/products/${ slug }`;